import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './no-workspaces.component.html',
  styleUrls: ['./no-workspaces.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoWorkspacesComponent {}
